export type OfferBrand = "tg";

export interface OfferItem {
  id: string;
  title: string;
  highlight?: string;
  priceInr: string;
  priceUsd: string;
  features: string[];
  featureSpacer?: boolean;
  stripeUrl: string;
  brand: OfferBrand;
}

export const offersPageHeader = {
  title: "Unlock Lifetime Access at a Yearly Price",
  subtitle:
    "Invest once for what you'd normally pay in a year and unlock the benefits forever. No renewals. No hidden charges. No limits.",
} as const;

export const comboOffers: OfferItem[] = [
  {
    id: "telegram-all-tools",
    title: "Telegram Tools Bundle",
    highlight: "Complete marketing bundle at 1 year's price for lifetime",
    priceInr: "₹5,999",
    priceUsd: "$100",
    features: [
      "All Telegram Web Extensions in 1 deal",
      "Send Bulk Telegram Messages",
      "Download Telegram Videos & Images",
    ],
    featureSpacer: true,
    stripeUrl: "https://buy.stripe.com/9B600kahP57DfMw2Yq7N601",
    brand: "tg",
  },
];

export const telegramToolsRow: OfferItem[] = [
  {
    id: "telegram-bulk-sender",
    title: "Telegram Bulk Sender",
    priceInr: "₹4,999",
    priceUsd: "$80",
    features: [
      "Send bulk messages",
      "Upload contacts via Excel",
      "Send attachments easily",
    ],
    stripeUrl: "https://buy.stripe.com/dRmcN60Hf57DdEoaqS7N600",
    brand: "tg",
  },
  {
    id: "telegram-video-downloader",
    title: "Telegram Video Downloader",
    priceInr: "₹2,999",
    priceUsd: "$60",
    features: [
      "Preview video duration",
      "Download Videos & Images in one click",
      "Track download progress",
    ],
    stripeUrl: "https://buy.stripe.com/dRm5kF0Bd8gB7lhduccs800",
    brand: "tg",
  },
];
